import { hasSubscriptionFlag } from '@/data/flags/local-flags';
import { activeSubHasPurchasedProductLine } from '@/data/flags/product-lines.js';

// EXPLORE PERMISSIONS

export const EXPLORE_STATUSES = {
    OFF: 'off',
    NOT_ALLOWED: 'not_allowed',
    SET_UP_NEEDS_SUB_FLAG: 'set_up_needs_sub_flag',
    SET_UP_NO_FLAG_NEEDED: 'set_up_no_flag_needed',
    PROCESSING: 'processing',
    READY: 'ready',
};

export function getExploreStatus () {
    const isEnabled = activeSubHasPurchasedProductLine('voc', 'exploreSettings.enabled');
    const freemiumEnabled = activeSubHasPurchasedProductLine('voc', 'freemium.enabled');
    if (!isEnabled || freemiumEnabled) return EXPLORE_STATUSES.OFF;

    const doNotProcessGoogleGenAi = hasSubscriptionFlag('doNotProcessGoogleGenAi');
    if (doNotProcessGoogleGenAi) return EXPLORE_STATUSES.NOT_ALLOWED;

    const hasExploreSubFlag = hasSubscriptionFlag('enableListenAIInsights');
    if (!hasExploreSubFlag) return EXPLORE_STATUSES.SET_UP_NEEDS_SUB_FLAG;

    const hasStartedSetup = activeSubHasPurchasedProductLine('voc', 'exploreSettings.exploreProcessing.enabledByUserId');
    if (!hasStartedSetup) return EXPLORE_STATUSES.SET_UP_NO_FLAG_NEEDED;

    const initSyncCompleted = activeSubHasPurchasedProductLine('voc', 'exploreSettings.initialSyncCompleted');
    if (!initSyncCompleted) return EXPLORE_STATUSES.PROCESSING;

    return EXPLORE_STATUSES.READY;
}

// FREEMIUM PERMISSIONS
export const FREEMIUM_STATUSES = {
    OFF: 'off',
    NOT_ALLOWED: 'not_allowed',
    SET_UP_NEEDS_SUB_FLAG: 'set_up_needs_sub_flag',
    SET_UP_NO_FLAG_NEEDED: 'set_up_no_flag_needed',
    PROCESSING: 'processing',
    READY: 'ready',
};

export function getFreemiumStatus () {
    const isEnabled = activeSubHasPurchasedProductLine('voc', 'freemium.enabled');
    if(!isEnabled) return FREEMIUM_STATUSES.OFF;

    const doNotProcessGoogleGenAi = hasSubscriptionFlag('doNotProcessGoogleGenAi');
    if(doNotProcessGoogleGenAi) return FREEMIUM_STATUSES.NOT_ALLOWED;

    const hasFreemiumSubFlag = hasSubscriptionFlag('enableListenAIInsights');
    if(!hasFreemiumSubFlag) return FREEMIUM_STATUSES.SET_UP_NEEDS_SUB_FLAG;

    const hasStartedSetup = activeSubHasPurchasedProductLine('voc', 'exploreSettings.exploreProcessing.enabledByUserId');
    if(!hasStartedSetup) return FREEMIUM_STATUSES.SET_UP_NO_FLAG_NEEDED;

    const initSyncCompleted = activeSubHasPurchasedProductLine('voc', 'exploreSettings.initialSyncCompleted');
    if(!initSyncCompleted) return FREEMIUM_STATUSES.PROCESSING;

    return FREEMIUM_STATUSES.READY;
}

export function hasDiscoverAIAccess () {
    if (!activeSubHasPurchasedProductLine('voc', 'feedback')) return false;

    const hasOpenAiDiscover = hasSubscriptionFlag('enableOpenAIDiscoverAI');
    const hasGoogleListenSummaries = hasSubscriptionFlag('enableGoogleListenSummariesAI');

    if (hasOpenAiDiscover || hasGoogleListenSummaries) return true;

    return false;
}

export function hasOpenAISummaryAccess () {
    if (!activeSubHasPurchasedProductLine('voc', 'feedback')) return false;

    return hasSubscriptionFlag('enableOpenAIDiscoverAI');
}
